import { FC } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { SubmenuType } from '@/config/navigationPages';
import { checkItemActive } from '../../SidebarNavSubmenuLink.helpers';
import NestedSubmenu from '../NestedSubmenu';

import styles from './NestedSubmenuItem.module.sass';

interface NestedSubmenuItemProps {
  item: SubmenuType;
  locationPathname: string;
  level?: number;
}

const NestedSubmenuItem: FC<NestedSubmenuItemProps> = ({
  item,
  locationPathname,
  level = 2,
}) => {
  const { t } = useTranslation();
  const isSubLinkActive = checkItemActive(item, locationPathname);

  const nestedSubMenu = item.subMenu ? Object.values(item.subMenu) : null;
  const shouldShowNested =
    isSubLinkActive && nestedSubMenu && nestedSubMenu.length > 0;

  const submenuClasses = cx(styles.sublink, {
    [styles['is-active']]: isSubLinkActive,
    [styles[`level-${level}`]]: level > 2,
  });

  if (!item.i18NameKey) return null;

  return (
    <>
      <Link className={submenuClasses} to={item.path}>
        <span className={styles.text}>{t(item.i18NameKey)}</span>
      </Link>
      {shouldShowNested && (
        <NestedSubmenu
          items={nestedSubMenu}
          locationPathname={locationPathname}
          level={level + 1}
        />
      )}
    </>
  );
};

export default NestedSubmenuItem;
